<template>
  <div class="quickscanmap">
    <div
      class="row no-gutters align-items-center"
      v-if="title"
      style="border-bottom: 1px solid #ddd; height: 56px"
    >
      <div class="col col-auto text-left">
        <h4 v-if="compareFeature">
          {{ title }} <i class="bi bi-arrow-right"></i> Details
        </h4>
        <h4 v-else>{{ title }}</h4>
      </div>

      <div class="col text-right" style="padding-right: 10px">
        <template v-if="compareFeature">
          <a
            href="#"
            style="margin: 5px"
            class="btn btn-outline-primary btn-sm"
            @click.prevent="compareFeature = null"
            >Close</a
          >
        </template>
        <template v-else>
          <ul class="cmd-group">
            <li class="title">
              <a href="#" @click.prevent="nextBackground">Background</a>
            </li>
            <li v-for="bg in backgroundLayers">
              <a
                href="#"
                :class="{ active: isActiveBackground(bg) }"
                @click.prevent="setBackground(bg)"
                >{{ bg.label }}</a
              >
            </li>
          </ul>
        </template>
      </div>
    </div>

    <div ref="alertsWrapper" class="alert-wrapper" style="display: block">
      <div class="row no-gutters" style="">
        <div class="col-12">
          <div ref="map" class="map" style="height: 490px; z-index: 10"></div>
        </div>
      </div>

      <div
        class="row no-gutters"
        v-if="backgroundLegendShow"
        style="pointer-events: none"
      >
        <div
          class="col col-4 offset-8"
          style="
            position: relative;
            top: -206px;
            margin-bottom: -200px;
            height: 200px;
            z-index: 900;
            border: 0px solid red;
            font-size: 0.9em;
          "
        >
          <div
            style="
              position: absolute;
              bottom: 0;
              right: 6px;
              padding: 0px;
              width: 100%;
              text-align: left;
              background-color: rgba(250, 250, 250, 0.9);
              padding: 5px;
              border: 1px solid #ccc;
            "
          >
            <RasterMapLegend
              v-if="background['legend']"
              v-bind:legend="background['legend']"
              v-bind:layout="{ legendWidth: 5, legendCols: 2 }"
              v-bind:loaded="loaded"
              isBackground="true"
            />
          </div>
        </div>
      </div>

      <div class="row no-gutters" v-if="loaded">
        <div style="padding: 3px 10px; width: 100%">
          <form name="table-config-form" style="width: 100%">
            <table
              class="table table-sm alerts-overview"
              style="
                font-size: 0.75em;
                border-bottom: 1px solid #ddd;
                width: 100%;
              "
              ref="alertsTable"
            >
              <tr>
                <th
                  colspan="17"
                  style="text-align:left;1px solid #ddd;border-top:0px;vertical-align:middle !important;padding-left:0px;"
                >
                  <span style="font-size: 1em"
                    >Table shows total area (in hectares) in which a change
                    occurred during the time period</span
                  >

                  <a
                    ref="csvDownloadLink"
                    @click.prevent="exportDataAs('csv')"
                    class="table-download-link"
                    href="#"
                    style="font-weight: normal; float: right; font-size: 0.8em"
                    ><i class="bi bi-cloud-download"></i> Download CSV</a
                  >
                </th>
              </tr>
              <tr>
                <td
                  colspan="1"
                  style="
                    padding: 5px;
                    vertical-align: middle;
                    text-align: center;
                    border-left: 1px solid #ddd;
                  "
                >
                  <i class="bi bi-funnel" style="font-size: 1.1em"></i>
                </td>
                <td
                  colspan="16"
                  style="
                    padding-left: 0px;
                    border-top: 1px solid #ddd;
                    border-right: 1px solid #ddd;
                  "
                >
                  <a
                    class="explainer-link"
                    style="float: right; padding-top: 5px"
                    href="#"
                    @click.prevent="explainerStart('ldr_alert_subselection')"
                    ><i class="bi bi-question-circle"></i
                  ></a>
                  <div style="padding: 4px; padding-left: 0px">
                    <div
                      class="form-check form-check-inline form-check-table"
                      v-for="category in categories"
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        v-model="selectedCategory"
                        name="inlineRadioOptions"
                        :id="uuid + '-' + category"
                        :value="category"
                      />
                      <label
                        class="form-check-label"
                        :for="uuid + '-' + category"
                        >{{ category }}</label
                      >
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  colspan="3"
                  style="
                    font-size: 0.9em;
                    padding-right: 0px;
                    border-left: 1px solid #dee2e6;
                    border-top: 2px solid #ccc;
                    width: 350px;
                  "
                >
                  Data source
                </th>
                <th class="slice-link" :rowspan="arrowRowSpan">
                  <a
                    title="Previous"
                    v-if="slotSliceStart > 0"
                    href="#"
                    @click.prevent="slotSlicePrev"
                    ><i class="bi bi-chevron-left"></i
                  ></a>
                  <span v-else style="color: #ddd"
                    ><i class="bi bi-chevron-left"></i
                  ></span>
                </th>
                <th
                  style="
                    text-align: center;
                    vertical-align: middle;
                    border: 1px solid #ddd;
                    font-size: 0.9em;
                    border-top: 2px solid #ccc;
                    padding: 0px 1px;
                    width: 75px;
                  "
                  :class="{ hovering: slotName && selectedSlot == slotName }"
                  v-for="slotName in slotNames"
                >
                  <span style="padding: 0px 3px">{{ slotName }}</span>
                </th>
                <th class="slice-link" :rowspan="arrowRowSpan">
                  <a
                    title="Next"
                    v-if="slotSliceEnd < slotNamesAll.length"
                    href="#"
                    @click.prevent="slotSliceNext"
                    ><i class="bi bi-chevron-right"></i
                  ></a>
                  <span v-else style="color: #ddd"
                    ><i class="bi bi-chevron-right"></i
                  ></span>
                </th>
              </tr>

              <template v-for="(alertSource, i) in alertSources">
                <tr :class="{ inActive: isInActiveSource(alertSource.name) }">
                  <td
                    style="
                      padding: 5px;
                      vertical-align: middle;
                      border-left: 1px solid #dee2e6;
                    "
                  >
                    <a
                      href="#"
                      :class="toggleSourceClass(alertSource.name)"
                      @click.prevent="toggleSource(alertSource.name)"
                      ><i class="bi bi-toggle-on" :style="colorByIndex(i)"></i
                      ><i class="bi bi-toggle-off" style="color: #aaa"></i
                    ></a>
                  </td>
                  <td style="vertical-align: middle">
                    <a
                      href="#"
                      @click.prevent="toggleSource(alertSource.name)"
                      style="color: #666"
                      ><nobr>
                        <span
                          v-if="alertSource.name == 'glad_forest_loss_alerts'"
                          >Forest Loss Alerts (GLAD)</span
                        >
                        <span v-else-if="alertSource.name == 'wur_radd_alerts'"
                          >Disturbance Alerts (RADD)</span
                        >
                        <span
                          v-else-if="alertSource.name == 'images_forest_alerts'"
                          >Forest Disturbances (IMAGES)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'hansen_forest_loss_hotspots'
                          "
                          >Tree Cover Loss (GFW)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'jrc_tmf_deforestation_hotspots'
                          "
                          >Tropical Forest Deforestation (JRC/EC)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'jrc_tmf_degradation_hotspots'
                          "
                          >Tropical Forest Degradation (JRC/EC)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'images_disturbance_hotspots'
                          "
                          >Forest Disturbances (IMAGES)</span
                        >
                        <span v-else-if="alertSource.name == 'ciat_terra_i'"
                          >Terra-i Disturbances (CIAT/Terra-i)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'cafi_deforestation_hotspots'
                          "
                          >CAFI Deforestation (FAO)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'cafi_degradation_hotspots'
                          "
                          >CAFI Forest Degradation (FAO)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'cafi_burned_area_hotspots'
                          "
                          >CAFI Burned Area (FAO)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'prodes_deforestation_hotspots'
                          "
                          >Deforestation (PRODES)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name ==
                            'mapbiomas_deforestation_hotspots'
                          "
                          >Deforestation (MapBiomas)</span
                        >
                        <span
                          v-else-if="
                            alertSource.name == 'jrc_surface_water_changes'
                          "
                          >Surface Water Increases (JRC)</span
                        >
                        <span v-else>{{ alertSource.name }}</span>
                      </nobr></a
                    >
                  </td>
                  <td>
                    <a
                      class="explainer-link"
                      style="display: block; padding-top: 2px"
                      href="#"
                      @click.prevent="explainerStart(alertSource.name)"
                      ><i class="bi bi-question-circle"></i
                    ></a>
                  </td>
                  <td
                    :class="{ hovering: slot && selectedSlot == slot.name }"
                    v-for="slot in slotsForSource(alertSource)"
                    style="
                      text-align: center;
                      vertical-align: middle;
                      border: 1px solid #ddd;
                    "
                  >
                    <a
                      class="slotLink"
                      v-if="slot"
                      href="#"
                      @click.prevent="selectedSlot = slot.name"
                      >{{ slot.size | m2ha }}</a
                    >
                    <span v-else>&ndash;</span>
                  </td>
                </tr>
              </template>
            </table>
          </form>
        </div>
      </div>
    </div>

    <CompareMap
      title="Alert Detail"
      v-bind:loaded="loaded"
      v-bind:compareFeature="compareFeature"
      v-bind:factsheet="factsheet"
      v-bind:location="location"
      v-bind:componentHeight="componentHeight"
    >
    </CompareMap>

    <div class="row no-gutters" v-if="attribution" style="padding-top: 5px">
      <p class="attribution">{{ attribution }}</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Leaflet from "leaflet";
import "leaflet/dist/leaflet.css";
import omnivore from "@mapbox/leaflet-omnivore";

import RasterMapLegend from "@/components/factsheet/RasterMapLegend.vue";
import CompareMap from "@/components/factsheet/ldr/maps/CompareMap.vue";

let uuid = 0;

export default {
  name: "AlertMap",
  components: { CompareMap, RasterMapLegend },
  props: [
    "numSlots",
    "slotType",
    "sources",
    "location",
    "source",
    "title",
    "description",
    "layout",
    "attribution",
    "factsheet",
    "loaded",
    "layers",
    "backgrounds",
  ],
  data() {
    return {
      numSlots: this.numSlots,
      numResults: 20,
      slotType: this.slotType,
      slotSliceStart: null,
      slotSliceEnd: null,
      areaThreshold: 0,
      selectedSlot: null,
      selectedSlotHover: "",
      alertSourcesList: this.sources.split(","),
      dataLayers: {},
      selectedSources: this.sources.split(","),
      mapBackground: null,
      legendBackground: null,
      backgroundLayers: [],
      background: null,
      backgroundLegendShow: false,
      opacities: [10, 50, 100],
      opacity: 100,
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      highlightHotspotFeature: null,
      analysisLayer: null,
      chartColors: [
        "ff7f0e",
        "9467bd",
        "8c564b",
        "e377c2",
        "7f7f7f",
        "bcbd22",
        "17becf",
        "2ca02c",
        "d62728",
      ],
      compareFeature: null,
      componentHeight: null,
      slots: [],
      categories: [],
      selectedCategory: "Full Landscape",
    };
  },
  beforeCreate() {
    this.uuid = "alertmap-" + uuid.toString();
    uuid += 1;
  },
  created() {
    //this.layer = this.layers[0]
  },
  updated() {
    console.log("Done loading map. Checking height:");
    this.componentHeight = this.$refs.alertsWrapper.offsetHeight;
    console.log(this.componentHeight);
  },
  mounted() {
    // Create the map
    this.map = L.map(this.$refs.map, {
      attributionControl: false,
      scrollWheelZoom: false,
      zoomControl: false,
    });
    L.control.scale().addTo(this.map);
    L.control.zoom({ position: "topleft" }).addTo(this.map);

    // Create relevant panes
    this.map.createPane("background");
    this.map.getPane("background").style.pointerEvents = "none";
    this.map.getPane("background").style.zIndex = 100;

    this.map.createPane("info");
    this.map.getPane("info").style.zIndex = 150;

    this.map.createPane("data");
    this.map.getPane("data").style.zIndex = 200;

    this.map.createPane("foreground");
    this.map.getPane("foreground").style.pointerEvents = "none";
    this.map.getPane("foreground").style.zIndex = 900;

    // Load backgrounds from factsheet config
    var backgrounds = this.factsheet["info"]["config"]["background_layers"];
    if (backgrounds) {
      _.forEach(backgrounds, (background) => {
        this.backgroundLayers.push(background);
      });
      this.background = backgrounds[0];
    }

    this.loadMap();
  },
  watch: {
    loaded() {
      this.loadMap();
      //this.loadLegend();
    },
    background() {
      if (this.mapBackground) {
        this.map.removeLayer(this.mapBackground);
      }
      if (this.background["type"] == "xyzlayer") {
        var url =
          process.env.VUE_APP_API +
          "/tools/layer/" +
          this.background["name"] +
          "/v" +
          this.background["version"] +
          "?z={z}&x={x}&y={y}";
        this.mapBackground = L.tileLayer(url, {
          attribution: "",
          maxZoom: 22,
          pane: "background",
        }).addTo(this.map);
      }
      if (this.background["type"] == "wmslayer") {
        var url =
          process.env.VUE_APP_API +
          "/tools/layer/" +
          this.background["name"] +
          "/v" +
          this.background["version"];
        this.mapBackground = L.tileLayer
          .wms(url, {
            attribution: "",
            maxZoom: 22,
            tileSize: 512,
            pane: "background",
          })
          .addTo(this.map);
      }
      if (this.background["type"] == "qgislayer") {
        var url =
          process.env.VUE_APP_API +
          "/tools/layer/" +
          this.background["name"] +
          "/v" +
          this.background["version"];
        this.mapBackground = L.tileLayer
          .wms(url, {
            attribution: "",
            maxZoom: 22,
            tileSize: 1024,
            pane: "background",
          })
          .addTo(this.map);
      }
      if (this.background["legend"]) {
        this.backgroundLegendShow = true;
      } else {
        this.backgroundLegendShow = false;
      }
    },
    opacity() {
      this.data.setOpacity(this.opacity / 100);
    },
    selectedSlot() {
      this.updateMap();
    },
    selectedCategory() {
      this.updateMap();

      if (this.aoiLayer) {
        //console.log("Fitting map to bounds:")
        //console.log(this.aoiLayer.getBounds())
        //this.map.fitBounds(this.aoiLayer.getBounds());
        this.map.fitBounds(this.aoiLayer.getBounds());
      }
    },
    selectedSources() {
      console.log("selected sources update...");
      this.updateMap();
    },
  },
  methods: {
    loadLegend() {
      if (this.layer) {
        /* Either fetch the legend, or use the one of the current layer. */
        if (this.layer && this.layer.hasOwnProperty("legend")) {
          if (this.layer["legend"]) {
            this.legend = this.layer["legend"];
          } else {
            var legendUrl =
              process.env.VUE_APP_API +
              "/tools/raster/legend/" +
              this.factsheet["identifier"] +
              "/" +
              this.layer["dataset_id"] +
              "/" +
              this.layer["filename"] +
              "~/legend.json";
            this.$axios.get(legendUrl).then((response) => {
              this.legend = response.data;
            });
          }
        }
      }
    },
    defaultSelectedSources() {
      var selectedSources = [];
      for (var i = 0; i < this.alertSources.length; i++) {
        if (this.alertSourcesList.includes(this.alertSources[i].name)) {
          selectedSources.push(this.alertSources[i].name);
        }
      }
      return selectedSources;
    },
    isInActiveSource(source) {
      if (this.selectedSources.includes(source)) {
        return false;
      } else {
        return true;
      }
    },
    toggleSource(source) {
      var ix = this.selectedSources.indexOf(source);
      if (ix >= 0) {
        this.selectedSources.splice(ix, 1);
      } else {
        this.selectedSources.push(source);
      }
    },
    toggleSourceClass(source) {
      if (this.selectedSources.includes(source)) {
        return "toggleSource toggleSourceOn";
      } else {
        return "toggleSource toggleSourceOff";
      }
    },
    exportDataAs(format) {
      var csv = [];
      var headers = [this.selectedCategory].concat(this.slotNamesAll);
      var rows = [];
      for (var i = 0; i < this.alertSources.length; i++) {
        var row = [];
        var slots = this.slotsForSource(this.alertSources[i], false);
        console.log("row for source:");
        console.log(this.alertSources[i]);
        for (var n = 0; n < slots.length; n++) {
          if (n == 0) {
            row.push(this.alertSources[i]["name"]);
          }
          if (slots[n]) {
            row.push((slots[n].size / 10000).toFixed(2));
          } else {
            row.push("");
          }
        }
        rows.push(row);
      }

      csv.push(headers);
      csv.push(...rows);
      let csvContent =
        "data:text/csv;charset=utf-8," + csv.map((e) => e.join(",")).join("\n");
      var encodedUri = encodeURI(csvContent);
      window.open(encodedUri);
      //this.$refs.csvDownloadLink.setAttribute("href", encodedUri);
      //this.$refs.csvDownloadLink.setAttribute("download", "my_data.csv");
    },
    slotsForSource(source, slice = true) {
      var slots = [];
      var slotNames = slice ? this.slotNames : this.slotNamesAll;
      for (var i = 0; i < slotNames.length; i++) {
        var findSlot = slotNames[i];
        var foundSlot = null;
        if (source.hasOwnProperty("slots")) {
          for (var n = 0; n < source.slots.length; n++) {
            if (
              findSlot == source.slots[n].name &&
              source.slots[n].category == this.selectedCategory
            ) {
              foundSlot = source.slots[n];
            }
          }
        }
        slots.push(foundSlot);
      }
      return slots;
    },
    categoryToLabel(category) {
      if (category == "Full Landscape") {
        return category;
      } else {
        return "– " + category;
      }
    },
    loadMap() {
      if (!this.loaded) {
        return;
      }

      console.log("Initial map load...");

      _.cloneDeep(this.location.layer).addTo(this.map);
      this.map.fitBounds(this.location.bounds);

      /* Add the data layers to the data pane */
      var categories = {};

      console.log("Adding alerts layers for which we have data...");
      for (var n = 0; n < this.alertSources.length; n++) {
        // Adding alertsources to the map.
        var alertSourceName = this.alertSources[n]["name"];
        this.dataLayers[alertSourceName] = L.tileLayer("", {
          attribution: "",
          maxZoom: 22,
          pane: "data",
        });
        this.dataLayers[alertSourceName].addTo(this.map);
        for (var s = 0; s < this.alertSources[n]["slots"].length; s++) {
          categories[this.alertSources[n]["slots"][s]["category"]] = true;
        }
      }
      this.categories = Object.keys(categories);
    },
    initMap() {},
    updateMap() {
      /* Manually update the geoJSON layer in the map */
      if (this.analysisLayer) {
        this.map.removeLayer(this.analysisLayer);
      }
      if (this.aoiLayer) {
        this.map.removeLayer(this.aoiLayer);
      }
      var pointsGeoJSON = this.pointsGeoJSON();
      var referenceSize = this.referenceSize();
      var aoiGeoJSON = this.aoiGeoJSON();

      if (aoiGeoJSON) {
        this.aoiLayer = L.geoJson(aoiGeoJSON, {
          interactive: false,
          style: {
            color: "#ff7800",
            weight: 2,
            opacity: 1.0,
            fillOpacity: 0.1,
          },
          pane: "info",
        });
        this.aoiLayer.addTo(this.map);
      }

      this.analysisLayer = L.geoJson(pointsGeoJSON, {
        interactive: false,
        pointToLayer: (feature, latlng) => {
          var size = parseInt(
            14 +
              19 *
                Math.sqrt(
                  parseInt(
                    10 *
                      (parseInt(feature["properties"]["area"]) / referenceSize)
                  )
                )
          );
          var border = 2;
          var top = parseInt(size / 2);
          var area_ha =
            parseInt(parseInt(feature["properties"]["area"]) / 10000) + "ha";
          var noval = "";

          if (size < 25) {
            noval = "no-val";
          }
          if (size > 30) {
            border = 3;
          }
          if (size > 50) {
            border = 4;
          }

          var myIcon = L.divIcon({
            iconSize: new L.Point(size, size),
            className:
              "hotspot-icon " +
              noval +
              " border-" +
              border +
              " hotspot-icon-color-" +
              feature["properties"]["color"],
            html: '<span style="top:' + top + 'px;">' + area_ha + "</span>",
          });
          return L.marker(latlng, { icon: myIcon });
        },
        onEachFeature: (feature, layer) => {
          layer.on("click", (e) => {
            this.compareFeature = e["target"]["feature"]["properties"];
          });
        },
      });
      this.analysisLayer.addTo(this.map);

      /* Set the data layer url based on the selectedSlots */
      for (var i = 0; i < this.alertSources.length; i++) {
        //console.log("checking for: "+this.alertSources[i]["name"])
        var url = "";

        if (this.selectedSources.includes(this.alertSources[i]["name"])) {
          url =
            process.env.VUE_APP_API +
            "/tools/raster/tile/" +
            this.factsheet["identifier"] +
            "/" +
            this.factsheet.dataset_ids[this.alertSources[i]["name"]] +
            "/" +
            this.selectedSlot +
            ".tif~/tile/{z}/{x}/{y}.png";
        } else {
          url = "";
        }
        this.dataLayers[this.alertSources[i]["name"]].setUrl(url);
      }
    },

    featuresGeoJSON() {
      return {
        type: "FeatureCollection",
        name: "hotspots",
        features: this.results,
      };
    },
    alerts() {
      /* filter results to the correct type */
      //console.log("Creating alerts from collection. Filtering by slot: "+this.selectedSlot+" and category: "+this.selectedCategory)
      var alerts = [];
      for (var i = 0; i < this.alertSources.length; i++) {
        if (!this.selectedSources.includes(this.alertSources[i].name)) {
          continue;
        }
        var subset = _.filter(this.alertCollection(), (result) => {
          //console.log(result)
          if (
            result["source"] == this.alertSources[i].name &&
            result["slot"] == this.selectedSlot &&
            result["category"] == this.selectedCategory
          ) {
            return true;
          } else {
            return false;
          }
        });
        alerts.push(...subset.slice(0, this.numResults));
      }
      console.log("Found " + alerts.length + " alerts.");
      return alerts;

      /* order by the selected sort order */
      //var sorted = _.sortBy(results, ['area', ], ['desc',])
      //var sorted = _.sortBy(results, [function(o) { return parseInt(o["properties"]["area"]); }]);

      //var reverse = _.reverse(sorted);
      //return _.reverse(sorted).slice(0, this.numRes)
    },
    alertCollection() {
      var alertCollection = [];
      for (var i = 0; i < this.alertSources.length; i++) {
        for (var n = 0; n < this.alertSources[i]["alerts"].length; n++) {
          var item = this.alertSources[i]["alerts"][n];
          item["color"] = this.chartColors[i];
          if (item["area"] > this.areaThreshold) {
            alertCollection.push(item);
          }
        }
      }
      console.log(
        "Alertcollection contains " + alertCollection.length + " items "
      );

      return alertCollection;
    },
    aoiGeoJSON() {
      /* Return a list of aois as geojson */
      var features = [];
      if (this.factsheet["filters"]) {
        _.forEach(this.factsheet["filters"]["features"], (feature) => {
          if (feature["properties"]["title"] == this.selectedCategory) {
            features.push(feature);
          }
        });
      }
      if (features.length > 0) {
        return {
          type: "FeatureCollection",
          name: "filter",
          features: features,
        };
      } else {
        console.log(
          "Could not find filter geometry for '" + this.selectedCategory + "'."
        );
        return null;
      }
    },
    pointsGeoJSON() {
      var features = [];
      _.forEach(this.alerts(), (feature) => {
        /* attach the original geometry as a "geom" property. this is usedin the popop. */
        //feature["properties"]["geom"] = feature["geometry"]
        features.push({
          type: "Feature",
          properties: feature,
          geometry: {
            type: "Point",
            coordinates: [feature["x"], feature["y"]],
          },
        });
      });
      return {
        type: "FeatureCollection",
        name: "hotspots",
        features: features,
      };
    },
    referenceSize() {
      var sorted = _.reverse(
        _.sortBy(this.alertCollection(), [
          function (o) {
            return parseInt(o["area"]);
          },
        ])
      );
      if (sorted[0]["area"] < 100000) {
        return 100000;
      } else {
        return sorted[0]["area"];
      }
    },
    loadLayer(layer) {
      this.layer = layer;
    },
    nextOpacity() {
      var current = this.opacities.indexOf(this.opacity);
      var next = (current + 1) % this.opacities.length;
      this.opacity = this.opacities[next];
    },
    isActiveOpacity(opacity) {
      return this.opacity == opacity;
    },
    isActiveLayer(layer) {
      return this.layer.title == layer;
    },
    setOpacity(opacity) {
      this.opacity = opacity;
    },
    backgroundColorByIndex(index) {
      return "background-color:#" + this.chartColors[index];
    },
    colorByIndex(index) {
      return "color:#" + this.chartColors[index];
    },
    slotSliceNext() {
      this.slotSliceStart += 1;
      this.slotSliceEnd += 1;
    },
    slotSlicePrev() {
      this.slotSliceStart -= 1;
      this.slotSliceEnd -= 1;
    },
    /* Background Layers functionality */
    setBackground(background) {
      this.background = background;
    },
    isActiveBackground(background) {
      return this.background["id"] == background["id"];
    },
    toggleBackgroundLegend() {
      if (this.backgroundLegendShow) {
        this.backgroundLegendShow = false;
      } else {
        this.backgroundLegendShow = true;
      }
    },
    nextBackground() {
      var current = 0;
      for (let i = 0; i < this.backgroundLayers.length; i++) {
        if (this.backgroundLayers[i]["id"] == this.background["id"]) {
          var current = i;
        }
      }
      var next = (current + 1) % this.backgroundLayers.length;
      this.background = this.backgroundLayers[next];
    },
  },
  filters: {
    int: function (value) {
      return parseInt(value);
    },
    percent: function (value) {
      return value.toFixed(1) + "%";
    },
    todate: function (value) {
      return value;
      //return value.slice(0,10);
    },
    tomonth: function (value) {
      return value.slice(0, 3);
    },
    toyear: function (value) {
      return value.slice(0, 4);
    },
    m2ha: function (value) {
      var ha = value / 10000;
      if (ha > 1000000) {
        return (ha / 1000000).toFixed(2) + "M";
      }
      if (ha > 100000) {
        return parseInt(ha / 1000) + "k";
      }
      if (ha > 10000) {
        return (ha / 1000).toFixed(1) + "k";
      }
      return parseInt(ha);
    },
    m2ha0: function (value) {
      return parseInt(value / 10000);
    },
    m2ha1: function (value) {
      return parseInt(value / 10000).toFixed(1);
    },
  },
  computed: {
    slotNamesAll() {
      const slotNames = new Set();
      for (var i = 0; i < this.alertSources.length; i++) {
        const slots = this.alertSources[i]["slots"];
        for (var n = 0; n < slots.length; n++) {
          slotNames.add(slots[n]["name"]);
        }
      }
      return [...slotNames].sort();
    },
    slotNamesSlice() {
      if (this.slotSliceStart == null || this.slotSliceEnd == null) {
        /* Initialize the slice and the selected slot. */
        this.slotSliceStart =
          this.slotNamesAll.length - parseInt(this.numSlots);
        this.slotSliceEnd = this.slotSliceStart + parseInt(this.numSlots);
      }
      return this.slotNamesAll.slice(this.slotSliceStart, this.slotSliceEnd);
    },
    slotNames() {
      const slice = this.slotNamesSlice;

      if (this.selectedSlot == null) {
        this.selectedSlot = this.slotNamesAll[this.slotSliceEnd - 1];
      }

      return slice;
    },
    arrowRowSpan() {
      return this.alertSources.length + 1;
    },
    alertSources() {
      var alertSources = [];
      for (var i = 0; i < this.alertSourcesList.length; i++) {
        if (this.factsheet["data"].hasOwnProperty(this.alertSourcesList[i])) {
          if (_.isEmpty(this.factsheet["data"][this.alertSourcesList[i]])) {
            console.log(
              "Skipping alert source " +
                this.alertSourcesList[i] +
                " because it is empty. Most likely outside of valid extent!"
            );
          } else {
            var alertSource = this.factsheet["data"][this.alertSourcesList[i]];
            //alertSource['dataset_id'] = this.factsheet.dataset_ids[this.alertSourcesList[i]]
            alertSources.push(alertSource);
          }
        }
      }
      return alertSources;
    },
    selectedSlotHoverStyle(slot) {
      if (this.selectedSlotHover == slot) {
        return "background-color:#fc3;";
      } else {
        return "";
      }
    },
    features() {
      var features = [];
      this.featureCollection.forEach((feat) => {
        if (feat["properties"]["type"] == this.analysislevel) {
          features.push(feat);
        }
      });
      return features;
    },

    downloadUrl() {
      if (this.layer == null) {
        return "";
      } else {
        return (
          process.env.VUE_APP_DATABUCKET +
          "/factsheet/" +
          this.factsheet.identifier +
          "/data" +
          this.layer["source"]
        );
      }
    },
    legendClass() {
      return (
        "col-sm-12 col-md-12 col-lg-" +
        (this.layout ? this.layout.legendWidth : 6)
      );
    },
    descriptionClass() {
      return (
        "col-sm-12 col-md-12 col-lg-" +
        (this.layout ? this.layout.descriptionWidth : 6)
      );
    },
  },
};
</script>
<style>
table.alerts-overview {
  margin: 0px;
  font-size: 0.8em;
}
table.alerts-overview tr.inActive a.slotLink {
  color: #bbb;
}

div.hotspot-icon {
  border-radius: 200px;
  text-align: center;
  font-weight: bold;
  border-style: solid;
}
div.border-5 {
  border-width: 5px;
}
div.border-4 {
  border-width: 3.7px;
}
div.border-3 {
  border-width: 3px;
}
div.border-2 {
  border-width: 2px;
}
div.no-val span {
  display: none !important;
}
.hovering {
  background-color: yellow;
  border: 1px solid #ddd;
}

div.hotspot-icon-color-ff7f0e {
  border-color: #ff7f0e;
  color: #ff7f0e;
}
div.hotspot-icon-color-2ca02c {
  border-color: #2ca02c;
  color: #2ca02c;
}
div.hotspot-icon-color-d62728 {
  border-color: #d62728;
  color: #d62728;
}
div.hotspot-icon-color-9467bd {
  border-color: #9467bd;
  color: #9467bd;
}
div.hotspot-icon-color-8c564b {
  border-color: #8c564b;
  color: #8c564b;
}
div.hotspot-icon-color-e377c2 {
  border-color: #e377c2;
  color: #e377c2;
}
div.hotspot-icon-color-7f7f7f {
  border-color: #7f7f7f;
  color: #7f7f7f;
}
div.hotspot-icon-color-bcbd22 {
  border-color: #bcbd22;
  color: #bcbd22;
}
div.hotspot-icon-color-17becf {
  border-color: #17becf;
  color: #17becf;
}

div.hotspot-icon span {
  display: block;
  position: relative;
  left: 0px;
  margin-top: -11px;
  text-shadow: 1px 1px 3px rgba(255, 255, 255, 0.9);
}
</style>

<style scoped>
div.form-check-table label {
  color: #333 !important;
  font-size: 0.9em;
}
a.explainer-link {
  float: right;
  color: #aaa;
}
a.explainer-link:hover {
  color: #0056b3;
}
a.toggleSource {
  display: block;
  margin-top: 2px;
  font-size: 1.4em;
}
a.toggleSourceOff i.bi-toggle-on {
  display: none;
}
a.toggleSourceOn i.bi-toggle-off {
  display: none;
}
div.info p {
  font-size: 0.6em;
  color: rgb(196, 104, 2);
  line-height: 1.3em;
}
div.quickscanmap {
  margin: 10px 0px 10px 0px;
}
h4 {
  margin: 0px;
  padding: 8px;
  padding-left: 10px;
  font-size: 0.9em;
  width: 100%;
  color: #444;
}
h5 {
  font-size: 0.7em;
  color: #666;
  font-weight: 600;
  padding: 5px 0px 5px 0px;
  margin: 0px;
}
p {
  margin: 0px;
  font-size: 0.6em;
  color: #222;
}
p.attribution {
  font-size: 0.5em;
  padding: 0px 6px 3px 6px;
  color: #888;
}
div.cmd,
div.row {
  background-color: #f5f5f5;
}
a.table-download-link {
  text-decoration: none;
  font-size: 0.75em;
  color: #666;
  //border:1px solid #ddd;
  //border:1px solid #f5f5f5;
  padding: 3px 4px;
}
a.table-download-link:hover {
  color: #0056b3;
  //background-color:#fff;
  //border:1px solid #ddd;
}
a.btn-command:focus,
a.btn-command:active {
  outline: none !important;
  box-shadow: none;
}
a.btn-command {
  background-color: #f5f5f5;
  color: #999;
}
a.btn-command:hover {
  background-color: #eeeeee;
  color: #777;
}
a.btn-command i {
  font-size: 0.8em;
}
div.legend-wrapper {
  padding: 7px;
}

ul.cmd-group {
  display: inline;
  font-size: 0.65em;
  border: 1px solid #bbb;
  border-radius: 2px;
  padding: 0;
  margin: 0;
  margin-left: 5px;
  background-color: #fff;
}
ul.cmd-group li {
  display: inline-block;
  margin: 0px;
  padding: 4px 2px 4px 2px;
}
ul.cmd-group li a.active {
  color: rgb(21, 176, 26);
}
ul.cmd-group li.title {
  padding-left: 0px;
}
ul.cmd-group li.title a {
  background-color: #f5f5f5;
  border-right: 1px solid #ccc;
  padding-right: 4px;
  padding-left: 3px;
  color: #777;
}
ul.cmd-group li a {
  padding-left: 2px;
  padding-right: 2px;
  color: #bbb;
}
ul.cmd-group li a svg {
  color: #aaa;
}
ul.cmd-group a.icon {
  font-size: 0.9em;
}
ul.cmd-group a:hover {
  color: #777;
}

ul.comment-list {
  margin: 0px;
  padding: 0px;
  list-style-type: none;
}
ul.comment-list li {
  font-size: 0.9em;
  margin: 1px 0px;
  //background-color:#fff;
  line-height: 1.4em;
  padding: 2px 0px;
}
div.layer-selection {
  font-size: 1em;
}
div.layer-selection a.btn-layer {
  color: #007bff;
}
div.layer-selection a.active {
  background-color: #fff;
}
div.layer-selection a.btn-layer:hover {
  color: #0056b3;
}

div.layer-commands {
  font-size: 1em;
}
div.layer-commands a.btn-layer {
  color: #aaa;
}
div.layer-commands a.btn-layer:hover {
  color: #0056b3;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}

div.legend-description p {
  margin-bottom: 5px;
}

form#quickscan-indicators div,
form#quickscan-analysislevel div {
  font-size: 0.75em;
}
form#quickscan-indicators .form-check-input:disabled ~ .form-check-label,
form#quickscan-analysislevel .form-check-input:disabled ~ .form-check-label {
  color: #aaa;
}

form.layer-selector-form {
  font-size: 0.75em;
  padding: 5px 10px;
  min-height: 140px;
  max-height: 140px;
  overflow-x: hidden;
  overflow-y: scroll;
}
form.layer-selector-form p,
form.feedback-form p {
  font-size: 15px;
  padding: 0px 0px;
  color: #666;
  margin-bottom: 7px;
}
form.feedback-form {
  font-size: 0.75em;
  padding: 7px 12px;
}
form.feedback-form label {
  font-size: 0.9em;
}
div.feedback-col {
  background-color: #fffad6;
}
div.feedback-col h6 {
  color: #c46802;
  font-weight: 600;
  margin: 3px 0px;
}
ul#result-list {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
ul#result-list li {
  padding: 0px;
  margin: 0px;
  margin-bottom: 5px;
  margin-left: 5px;
}
ul#result-list li:last-child {
  margin-bottom: 0px;
}
div.result-list-box {
  line-height: 0.95em;
}
div.result-list-box a {
  display: block;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  color: #333;
}
div.result-list-box a:hover {
  border: 1px solid #aaa;
  background-color: #fff;
}
div.result-list-box a:hover h6 {
  color: #007bff;
}
div.result-list-box span.sub {
  font-size: 0.9em;
}
div.result-list-box a h6 {
  margin: 0px;
  padding: 0px;
  font-size: 1.1em;
  font-weight: bold;
  color: #007bff;
}
table.mini {
  width: 100%;
  font-size: 0.7em;
}
table.mini,
table.mini tr,
table.mini td {
  margin: 0px;
  padding: 0px;
}
table.mini td,
table.mini th {
  padding-left: 3px;
  padding-right: 3px;
}
table.mini td {
  text-align: center;
  border-left: 1px dotted #888;
}
table.mini th {
  font-weight: bold;
  text-align: center;
  border-bottom: 1px dotted #888;
  border-left: 1px dotted #888;
  padding-left: 3px;
  padding-right: 3px;
}
table.mini td:first-child,
table.mini th:first-child {
  text-align: left;
  padding: 0px;
  width: 100%;
  border-left: 0px;
}
div.sort-options {
  border-bottom: 0px solid #ccc;
  margin-bottom: 5px;
  font-size: 0.6em;
  margin: 0px 5px 0px 5px;
  padding: 5px;
  padding-top: 0px;
  font-weight: bold;
  color: #666;
}

a.sort-option {
  font-weight: normal;
}

th.slice-link {
  overflow: hidden;
  font-size: 1.3em;
  padding: 0px;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #ddd;
  border-top: 2px solid #ccc;
}
th.slice-link a {
  display: block;
  margin: -10em;
  padding: 10em;
}
th.slice-link a:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
</style>
